




















import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { defineComponent } from '@vue/composition-api';

import helpUIStoreIndex from '@store/modules/ui/help/helpIndex';

export default defineComponent({
    name: 'ModalHeader',
    props: {
        isTextTitle: {
            type: Boolean,
            required: false,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
        isHelpDisplayed: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
    setup() {
        const helpUIStore = useVuexStore<typeof helpUIStoreIndex>('ui/help');

        const showHelp = helpUIStore.action('showHelp');

        return {
            showHelp,
        };
    },
});
